/**
 * useHashLocation -- React hook for hash-based URL location.
 *
 * Returns [path, navigate] where path is the hash path (without #)
 * and navigate is a function to change the hash location.
 */
import { useState, useEffect, useCallback } from "react";

function getHashPath(): string {
  const hash = window.location.hash;
  // Remove leading # and return path, defaulting to "/"
  return hash.startsWith("#") ? hash.slice(1) || "/" : "/";
}

export function useHashLocation(): [string, (to: string) => void] {
  const [path, setPath] = useState(getHashPath);

  useEffect(() => {
    const handler = () => setPath(getHashPath());
    window.addEventListener("hashchange", handler);
    return () => window.removeEventListener("hashchange", handler);
  }, []);

  const navigate = useCallback((to: string) => {
    window.location.hash = to;
  }, []);

  return [path, navigate];
}
